export type Language = 'en' | 'zh' | 'ko' | 'es';

export const TRANSLATIONS = {
  en: {
    nav_about: "About Ike",
    nav_services: "Services",
    nav_locations: "Locations",
    nav_pricing: "Pricing",
    nav_student: "Student & Faculty",
    hero_badge: "Brisbane's #1 Fixed-Price Specialist",
    hero_title: "Fast, Trusted Computer Repairs for ",
    hero_span: "Brisbane Seniors.",
    hero_desc: "Master Technician. Transparent Prices. Same-Day Service. We fix it right the first time—at your home or our lab.",
    hero_btn_book: "Book Same-Day Repair",
    hero_btn_pricing: "See Fixed Prices",
    about_badge: "The Gold Standard of Repairs",
    about_title: "Unrivaled Precision. ",
    about_span: "Pure Local Trust.",
    about_quote: "For 15 years, I’ve been Brisbane’s 'hidden secret' for reviving laptops that other shops said were impossible to fix.",
    about_btn: "Meet the Master Tech",
    whatsapp: "WhatsApp",
    call_ike: "Call Ike",
    footer_tagline: "Fast, trusted computer repairs for Brisbane seniors and families. Serving the local community for over 15 years.",
    footer_emergency: "Open Mon–Sun, 8:00 AM to 9:00 PM for emergencies.",
    student_discount: "10% Student Discount",
    urgent_deadline: "Assignment Due? Priority 24hr Turnaround."
  },
  zh: {
    nav_about: "关于 Ike",
    nav_services: "服务项目",
    nav_locations: "服务区域",
    nav_pricing: "价格查询",
    nav_student: "师生特惠",
    hero_badge: "布里斯班排名第一的固定价格专家",
    hero_title: "为布里斯班长辈提供 ",
    hero_span: "快速、可靠的电脑维修。",
    hero_desc: "大师级技师。透明一口价。当天上门。无论是您的家还是我们的实验室，我们都能一次性彻底修复。",
    hero_btn_book: "预约当天维修",
    hero_btn_pricing: "查看固定价格",
    about_badge: "维修行业的黄金标准",
    about_title: "无与伦比的精度。 ",
    about_span: "纯正的本地信任。",
    about_quote: "15年来，我一直是布里斯班的“秘密武器”，专门修复那些被其他店认为无法修理的电脑。",
    about_btn: "会见首席技师",
    whatsapp: "微信/WhatsApp",
    call_ike: "致电 Ike",
    footer_tagline: "为布里斯班长辈和家庭提供快速、可靠的电脑维修。服务社区超过15年。",
    footer_emergency: "周一至周日，上午8:00至晚上9:00（紧急情况拨打）。",
    student_discount: "学生专享10%优惠",
    urgent_deadline: "作业截止？24小时优先修复。"
  },
  ko: {
    nav_about: "Ike 소개",
    nav_services: "서비스 안내",
    nav_locations: "서비스 지역",
    nav_pricing: "수리 비용",
    nav_student: "학생 및 교직원",
    hero_badge: "브리즈번 No.1 정찰제 컴퓨터 수리",
    hero_title: "브리즈번 어르신들을 위한 ",
    hero_span: "빠르고 정직한 수리 서비스.",
    hero_desc: "15년 경력 마스터 엔지니어. 투명한 정찰제 가격. 당일 방문 서비스. 집이나 연구소에서 단 한 번에 완벽하게 해결해 드립니다.",
    hero_btn_book: "당일 수리 예약하기",
    hero_btn_pricing: "정찰제 가격 확인",
    about_badge: "수리 서비스의 골드 스탠다드",
    about_title: "독보적인 기술력. ",
    about_span: "신뢰할 수 있는 이웃.",
    about_quote: "15년 동안 저는 브리즈번에서 다른 수리점이 포기한 노트북을 살려내는 '숨겨진 전문가'로 통했습니다.",
    about_btn: "마스터 엔지니어 상담",
    whatsapp: "와츠앱",
    call_ike: "Ike에게 전화",
    footer_tagline: "브리즈번 어르신들과 가족들을 위한 빠르고 믿을 수 있는 컴퓨터 수리. 15년 이상 지역 사회와 함께합니다.",
    footer_emergency: "월-일, 오전 8:00 ~ 오후 9:00 (긴급 수리 가능).",
    student_discount: "학생 10% 할인",
    urgent_deadline: "과제 마감 임박? 24시간 우선 수리."
  },
  es: {
    nav_about: "Sobre Ike",
    nav_services: "Servicios",
    nav_locations: "Ubicaciones",
    nav_pricing: "Precios",
    nav_student: "Estudiantes y Facultad",
    hero_badge: "Especialista #1 en Precios Fijos en Brisbane",
    hero_title: "Reparaciones Rápidas y Seguras para ",
    hero_span: "Personas Mayores en Brisbane.",
    hero_desc: "Técnico Maestro. Precios Transparentes. Servicio el Mismo Día. Lo reparamos bien a la primera, en su hogar o en nuestro laboratorio.",
    hero_btn_book: "Reservar Reparación Hoy",
    hero_btn_pricing: "Ver Precios Fijos",
    about_badge: "El Estándar de Oro en Reparaciones",
    about_title: "Precisión Inigualable. ",
    about_span: "Confianza Local Pura.",
    about_quote: "Durante 15 años, he sido el 'secreto guardado' de Brisbane para revivir laptops que otras tiendas daban por perdidas.",
    about_btn: "Contactar al Maestro",
    whatsapp: "WhatsApp",
    call_ike: "Llamar a Ike",
    footer_tagline: "Reparaciones rápidas y confiables para personas mayores y familias en Brisbane. Más de 15 años de servicio local.",
    footer_emergency: "Abierto de lunes a domingo, de 8:00 AM a 9:00 PM para emergencias.",
    student_discount: "10% de Descuento Estudiantil",
    urgent_deadline: "¿Entrega Urgente? Prioridad en 24 horas."
  }
};